import React, {useState} from 'react';
import S from 'StyledChangePasswordForm.js';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import {translation} from 'helpers/utilsHelper.js';
import ModalOpacity from 'ModalOpacity.js';
import useToggle from 'UseToggle.js'
import _get from 'lodash/get';
import Icon from 'eye-off.svg';

// Validation
import validation from 'sb-validate-js/validate.js';
import validators from 'validators.enum.js';

const validate = values => {
    const errors = validation(values, validators.CHANGE_PASSWORD);
    return errors;
};

const renderField = ({
    input,
    type,
    placeholder,
    meta: {touched, error, warning}
}) => {
    return (
        <S.Row>
            <S.InputWrapper>
                <S.Input {...input} type={type} required="required" placeholder={placeholder} />
                {touched && ((error && <S.Error>{error[0]}</S.Error>) || (warning && <S.Error>{warning}</S.Error>))}
            </S.InputWrapper>
        </S.Row>
    )
};

const ChangePasswordForm = ({changePasswordOnSubmit, handleSubmit, userId, pristine, submitting, error, toggleChangePasswordModal}) => {

    const [showSuccessModal, toggleSuccessModal] = useToggle(false);
    const [showPassword, setshowPassword] = useState(Array(3).fill(false));

    const onFormSubmit = async(values) => {
        try {
            const params = {
                oldValue: _get(values, 'oldPassword'),
                newValue: _get(values, 'newPassword'),
                customerId: userId
            };

            await changePasswordOnSubmit(params);
            toggleSuccessModal();
        } catch (err) {
            throw new SubmissionError({_error: err});
        }
    };

    const changeInputType = (inputId) => {
        const show = [...showPassword];
        show[inputId] = !show[inputId]
        setshowPassword(show)
    };

    return (
        <S.ChangePasswordForm method="post">

            <ModalOpacity isOpen={showSuccessModal} toggleOpen={toggleSuccessModal} showHeaderIcon={false} showHeaderTitle={false}>
                <S.SuccessModal>
                    <S.SuccessModalTitle>{translation('account_changePasswordForm_successTitle')}</S.SuccessModalTitle>
                    <S.SuccessModalMessage>{translation('account_changePasswordForm_success')}</S.SuccessModalMessage>
                </S.SuccessModal>
            </ModalOpacity>

            
            <S.Label>{translation('account_changePasswordForm_oldPassword')}</S.Label>
            <S.Wrapper>
                <Field
                    name="oldPassword"
                    type={showPassword[0] ? "text" : "password"}
                    placeholder={translation('account_changePasswordForm_oldPassword_input')}
                    component={renderField}
                />
                <S.IconShowPassword onClick={() => changeInputType(0)} dangerouslySetInnerHTML={{__html: Icon}}/>
            </S.Wrapper>
            
            <S.Label>{translation('account_changePasswordForm_newPassword')}</S.Label>
            <S.Wrapper>
                <Field
                    name="newPassword"
                    type={showPassword[1] ? "text" : "password"}
                    placeholder={translation('account_changePasswordForm_newPassword_input')}
                    component={renderField}
                />
                <S.IconShowPassword onClick={() => changeInputType(1)} dangerouslySetInnerHTML={{__html: Icon}}/>
            </S.Wrapper>
            <S.Label>{translation('account_changePasswordForm_confirmNewPassword')}</S.Label>
            <S.Wrapper>
                <Field
                    name="confirmPassword"
                    type={showPassword[2] ? "text" : "password"}
                    placeholder={translation('account_changePasswordForm_confirmNewPassword_input')}
                    component={renderField}
                />
                <S.IconShowPassword onClick={() => changeInputType(2)} dangerouslySetInnerHTML={{__html: Icon}}/>
            </S.Wrapper>
            {error && <S.SubmissionError className="submission-error">{error}</S.SubmissionError>}
            <S.BtnWrapper>
                <S.CloseBtn onClick={toggleChangePasswordModal}>{translation('account_changePasswordForm_changePassword_close_button')}</S.CloseBtn>
                <S.SubmitBtn onClick={handleSubmit(onFormSubmit)} disabled={pristine || submitting}>{translation('account_changePasswordForm_changePassword_submit_button')}</S.SubmitBtn>
            </S.BtnWrapper>
        </S.ChangePasswordForm>
    );
}

export default reduxForm({
    form: 'changePasswordForm',
    validate
})(ChangePasswordForm)
